import { render } from "./WhyTataBook.vue?vue&type=template&id=731649a9"
import script from "./WhyTataBook.vue?vue&type=script&lang=js"
export * from "./WhyTataBook.vue?vue&type=script&lang=js"

import "./WhyTataBook.vue?vue&type=style&index=0&id=731649a9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__